$(document).foundation();

var kimal  = {
  development: false,
  $window: $(window),
  $document: $(document),
  $body: $('body'),
  $pageElems: $('html,body'),
  $preloader: $('#preloader-logo-container'),
  $mainNav: $('#main-nav'),
  $header: $('#main-header'),
  $headerLogo: $('#header-logo'),
  $hamburger: $('#hamburger'),
  $topBar: $('.header__top-bar'),
  $distributorModal: $('#distributor-modal'),
}
